import RoomServiceOutlinedIcon from '@mui/icons-material/RoomServiceOutlined'
import { Box, Button, Stack, Typography } from '@mui/material'

import type { AvisoCocina } from '../contexts/avisosCocinaContext.ts'
import { minutosDesde, textoMinutos } from '../utils/comandaCocina.ts'

interface AvisoCocinaItemProps {
  aviso: AvisoCocina
  ahora: number
  ocupado: boolean
  onEntregar: (aviso: AvisoCocina) => void
}

/** Fila compacta de un aviso: "Orden #12 lista · Terraza · Mesa 5 · Cocina · hace 2 min" */
const AvisoCocinaItem = ({ aviso, ahora, ocupado, onEntregar }: AvisoCocinaItemProps) => {
  const minutos = minutosDesde(aviso.fechaListo, ahora)
  const detalle = [aviso.destino, aviso.areaNombre, minutos !== null ? textoMinutos(minutos) : null]
    .filter(Boolean)
    .join(' · ')

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1.25, opacity: ocupado ? 0.6 : 1 }}>
      <RoomServiceOutlinedIcon fontSize="small" sx={{ color: 'success.main', flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
          Orden #{aviso.numero} lista
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }} noWrap>
          {detalle}
        </Typography>
      </Box>
      <Button
        size="small"
        color="success"
        variant="outlined"
        disabled={ocupado}
        onClick={() => onEntregar(aviso)}
        sx={{ flexShrink: 0, minWidth: 0, px: 1 }}
      >
        Entregado
      </Button>
    </Stack>
  )
}

export default AvisoCocinaItem
